import React from 'react';

import { LucidTheme } from '@lucid/theme';
import { keyframes } from '@emotion/react';
import { isBrowser } from '@lucid/utils';

import Icon, { IconType } from '../icon/icon';

const icons = [
  {
    key: 'twitter',
    bgColor: '#00AEED',
    href: 'https://twitter.com/share?url=',
    icon: 'Twitter'
  },
  {
    key: 'linkedin',
    bgColor: '#007CB6',
    href: 'https://linkedin.com/shareArticle?url=',
    icon: 'Linkedin'
  },
  {
    key: 'facebook',
    bgColor: '#3B5898',
    href: 'https://www.facebook.com/sharer/sharer.php?u=',
    icon: 'Facebook'
  }
];

const slideOut = keyframes({
  '0%': {
    transform: 'translate(100%, -100%)'
  },
  '100%': {
    transform: 'translate(0, -100%)'
  }
});

const ShareIcons: React.FC = () => {
  const url = isBrowser() && window.location.href;

  return (
    <aside
      css={(theme: LucidTheme) => ({
        animation: `0.75s ease-in-out ${slideOut}`,
        position: 'fixed',
        right: 0,
        top: '50%',
        transform: 'translateY(-100%)',
        zIndex: theme.zIndices[2]
      })}
    >
      {icons.map(({ key, bgColor, href, icon }) => (
        <a
          key={key}
          css={(theme: LucidTheme) => ({
            backgroundColor: bgColor,
            borderRadius: '50%',
            display: 'block',
            height: '46px',
            padding: theme.space[2],
            width: '46px'
          })}
          href={`${href}${url}`}
          rel="noreferrer"
          target="_blank"
        >
          <Icon
            color="white"
            sizing="responsive"
            type={icon as IconType}
          />
        </a>
      ))}
    </aside>
  );
};

export default ShareIcons;
